import { render, staticRenderFns } from "./poetry_detail.vue?vue&type=template&id=3d53e5cb&"
import script from "./poetry_detail.vue?vue&type=script&lang=js&"
export * from "./poetry_detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports